import React, { useEffect, useRef, useState } from 'react';
import cartoon1 from '../../assets/images/cartoon2.webp';

export default function PeekingCartoonCharacter() {
  const containerRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const target = containerRef.current?.parentElement || document.getElementById('store-section');
    if (!target) return;

    // Detect when user scrolls into the cards area
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -40px 0px',
      }
    );

    observer.observe(target);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={containerRef}
      className={`absolute -left-10 sm:-left-12 lg:-left-16 xl:-left-20 2xl:-left-72 -top-8 lg:-top-12 xl:-top-16 z-0 pointer-events-none select-none hidden xl:block transition-all duration-1000 ease-out ${
        isVisible
          ? 'translate-x-0 opacity-100'
          : '-translate-x-[125%] opacity-0'
      }`}
      style={{
        perspective: '1000px',
        transitionTimingFunction: 'cubic-bezier(0.16, 1, 0.3, 1)',
      }}
      aria-hidden="true"
    >
      {/* Ambient Cyber Neon Glow behind character */}
      <div
        className={`absolute -left-10 top-1/4 w-36 h-64 xl:w-48 xl:h-96 bg-cyber-blue/25 rounded-full blur-[80px] pointer-events-none transition-opacity duration-1000 ${
          isVisible ? 'opacity-100 animate-pulse-slow' : 'opacity-0'
        }`}
      />
      <div
        className={`absolute left-4 top-1/2 w-32 h-56 xl:w-40 xl:h-80 bg-cyber-pink/20 rounded-full blur-[70px] pointer-events-none transition-opacity duration-1000 ${
          isVisible ? 'opacity-100' : 'opacity-0'
        }`}
      />

      {/* Floating 3D Character Container */}
      <div
        className="relative"
        style={{
          transformStyle: 'preserve-3d',
        }}
      >
        {/* Animated Peeking Image */}
        <div className={isVisible ? 'animate-character-float' : ''}>
          <img
            src={cartoon1}
            alt="Store Guardian Character"
            className="h-[480px] lg:h-[440px] xl:h-[580px] 2xl:h-[660px] w-auto object-contain object-left filter drop-shadow-[0_10px_25px_rgba(0,0,0,0.85)] drop-shadow-[0_0_25px_rgba(0,240,255,0.35)]"
            loading="lazy"
            decoding="async"
          />
        </div>
      </div>

      <style>{`
        @keyframes characterFloat {
          0% {
            transform: translateY(0px) rotate(0deg);
          }
          50% {
            transform: translateY(-14px) rotate(0.8deg);
          }
          100% {
            transform: translateY(0px) rotate(0deg);
          }
        }
        .animate-character-float {
          animation: characterFloat 6s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
}
